import { ApplicantStatus } from '@components/templates/employer/applicant-list/functions';
import { McFlowCardData } from '@components/templates/employer/applicant-list/flow-mc/flow-types';
import { McProfileSource, McUnifiedProfileQueryParams } from '@components/templates/employer/applicant-list/flow-mc/types';

export type McApplicantsSourceFilter = 'applicants' | 'recommended' | 'uploaded';
export type McApplicantsSourceFilterValue = McApplicantsSourceFilter | null;
export type McFlowColumnType = 'rejected' | 'applicants' | 'shortlist' | 'interview';

export const mcApplicantsSourceFilterLabelKeys: Record<McApplicantsSourceFilter, string> = {
  applicants: 'flow.column.applicants',
  recommended: 'flow.column.recommended',
  uploaded: 'mc.applicant.uploaded',
};

export const mcFlowColumnStatusMap: Record<McFlowColumnType, ApplicantStatus> = {
  rejected: ApplicantStatus.REJECTED,
  applicants: ApplicantStatus.NEW,
  shortlist: ApplicantStatus.SHORTLIST,
  interview: ApplicantStatus.INTERVIEW,
};

export const mcFlowColumnStatusesQueryMap: Record<McFlowColumnType, string> = {
  rejected: `${ApplicantStatus.REJECTED}`,
  applicants: `${ApplicantStatus.NEW},${ApplicantStatus.VIEWED}`,
  shortlist: `${ApplicantStatus.SHORTLIST}`,
  interview: `${ApplicantStatus.INTERVIEW},${ApplicantStatus.OFFER},${ApplicantStatus.HIRED}`,
};

const normalizeStatusesQuery = (statuses?: string) => (
  statuses
    ?.split(',')
    .map((status) => status.trim())
    .filter(Boolean)
    .sort((left, right) => Number(left) - Number(right))
    .join(',')
);

export const getMcFlowStatusContext = (
  queryParams?: Pick<McUnifiedProfileQueryParams, 'status' | 'statuses'>,
) => {
  if (typeof queryParams?.status === 'number') {
    return queryParams.status;
  }

  const normalizedStatuses = normalizeStatusesQuery(queryParams?.statuses);
  if (!normalizedStatuses) return undefined;

  return (Object.entries(mcFlowColumnStatusesQueryMap).find(([, statuses]) => (
    normalizeStatusesQuery(statuses) === normalizedStatuses
  ))?.[0] as McFlowColumnType | undefined);
};

const mcApplicantsSourceFilterProfileSources: Record<McApplicantsSourceFilter, McProfileSource[]> = {
  applicants: ['applicant'],
  recommended: ['recommended_candidate'],
  uploaded: ['saved_profile', 'matching_candidate'],
};

export const filterMcApplicantsSourceItems = (
  items: McFlowCardData[],
  filter: McApplicantsSourceFilterValue,
) => {
  if (!filter) return items;

  return items.filter((item) => {
    const profileSource = item.mcProfileSource;

    if (!profileSource) return false;

    return mcApplicantsSourceFilterProfileSources[filter].includes(profileSource);
  });
};
